/**
 * AgentSuggestionBar Component
 * Indicatore compatto dell'agent AI sopra l'area di input.
 * I suggerimenti dettagliati sono nel ChatAgentPanel.
 */

import { memo } from 'react';
import { Bot, Loader2, Zap, ChevronRight } from 'lucide-react';
import type { AgentRequest } from '@/lib/types/whatsappAgent';

interface AgentSuggestionBarProps {
  suggestions: AgentRequest[];
  isAgentActive: boolean;
  isAnalyzing?: boolean;
  onTriggerAnalysis?: () => void;
  onOpenAgentPanel?: () => void;
}

export const AgentSuggestionBar = memo(function AgentSuggestionBar({
  suggestions,
  isAgentActive,
  isAnalyzing = false,
  onTriggerAnalysis,
  onOpenAgentPanel,
}: AgentSuggestionBarProps) {
  if (!isAgentActive) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 border-t border-[rgba(55,53,47,0.09)] dark:border-white/10 bg-[rgba(55,53,47,0.02)] dark:bg-white/[0.02]">
      <Bot className="w-3.5 h-3.5 text-green-600 flex-shrink-0" />
      <span className="text-xs text-[#787774] flex-1">
        Agent attivo
        {isAnalyzing
          ? ' · Analisi in corso...'
          : suggestions.length > 0
            ? ` · ${suggestions.length} suggeriment${suggestions.length === 1 ? 'o' : 'i'}`
            : ' · Nessun suggerimento'
        }
      </span>

      {isAnalyzing ? (
        <Loader2 className="w-3.5 h-3.5 text-blue-500 animate-spin flex-shrink-0" />
      ) : (
        <div className="flex items-center gap-1">
          {onTriggerAnalysis && (
            <button
              onClick={onTriggerAnalysis}
              className="flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded transition-colors"
            >
              <Zap className="w-3 h-3" />
              Analizza
            </button>
          )}
          {suggestions.length > 0 && onOpenAgentPanel && (
            <button
              onClick={onOpenAgentPanel}
              className="flex items-center gap-0.5 px-2 py-0.5 text-[11px] font-medium text-[#787774] hover:text-[#37352F] dark:hover:text-white hover:bg-[rgba(55,53,47,0.04)] dark:hover:bg-white/5 rounded transition-colors"
            >
              Vedi
              <ChevronRight className="w-3 h-3" />
            </button>
          )}
        </div>
      )}
    </div>
  );
});
